void import("./App").catch((error) => {
  console.error("Failed to load the application", error);
});
